import { useTextTranslation } from "../../utils/useTextTranslation";
import { toTrackId } from "../../analytics/trackIds";
import React, { useContext, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import WatchTvIcon from "../../assets/icons/svg/WatchTvIcon";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import { getBroadcastCopy } from "../../statics/broadcastCopy";

const IconRender = (props) => {
  const translateText = useTextTranslation();
  const ref = useRef(null);
  const { selectedMenuId, path, setShowLoginMessage, setSelectedGenre } =
    useContext(SessionContext);
  const history = useHistory();
  const location = useLocation();
  const onClickMenu = () => {
    if (
      props.text === localizationStrings.specialForMe ||
      props.text === localizationStrings.series
    ) {
      if (localStorage.getItem("usertype") === "0") {
        // let lang = localStorage.getItem("language");
        // let deviceid = localStorage.getItem("deviceid");
        // let softLoginUrl = localStorage.getItem("loginurl");
        // let loginUrl = `${softLoginUrl}?lan=${
        //   lang ? lang : "tur"
        // }&deviceid=${deviceid}`;
        // window.location.replace(loginUrl);
        setShowLoginMessage(true);
        return;
      }
    }

    if (props.link === "livetv") {
      setSelectedGenre({ id: "all", name: getBroadcastCopy().all });
    }
    let url =
      props.link !== "livetv"
        ? `/dashboard/home/${props.link}/all`
        : "/dashboard/livetv/all";

    history.push(url);
  };

   const isActive = () => {
    const currentPath = location.pathname;
    
    if (props.link === "livetv") {
      return currentPath.includes("/dashboard/livetv") || currentPath.includes("/dashboard/tvguide");
    } else {
      return selectedMenuId == props.link;
    }
  };

  return (
    <a
      style={{ textDecoration: "none" }}
      data-track-id={toTrackId("nav_menu", props.link)}
      className={`menu-item ${isActive() ? "is-active" : ""}`}
      href={`#/dashboard/${props.link === "livetv" ? "livetv/all" : `home/${props.link}/all`}`}
      aria-current={isActive() ? "page" : undefined}
      onClick={(event) => { event.preventDefault(); onClickMenu(); }}
    >
      <div className="category centered" ref={ref}>
        {/* {props.link === "livetv" ? (
          <div style={{ display: "flex", alignItems: "center" }}>
            {path?.includes("/dashboard/live") ? (
              <div className="watch-tv-selected">
                {localizationStrings.watchTv}
              </div>
            ) : (
              <WatchTvIcon text={localizationStrings.watchTv} />
            )}
          </div>
        ) : ( */}
        <label>{translateText(props.link === "home" ? localizationStrings.home : props.text)}</label>
        {/* )} */}
      </div>
    </a>
  );
};

export default IconRender;
